import { get, post,postFile } from "./index.js";

//   登录
export const login = param => {
  const params = {
    url: "/app-api/member/auth/login",
    body: { ...param }
  };
  return post(params);
};
// 忘记密码
export const forgetPassword = param => {
  const params = {
    url: "/app-api/member/auth/forget-password",
    body: { ...param }
  };
  return post(params);
};

// 发送验证码
export const sendEmailCode = param => {
  const params = {
    url: "/app-api/member/auth/send-email-code",
    body: { ...param }
  };
  return post(params);
};

// 用户-基本信息
export const userInfo = param => {
  const params = {
    url: '/app-api/member/user/get',
    query: { ...param },
  }
  return get(params)
}

// 修改用户名
export const updateNickname = param => {
  const params = {
    url: "/app-api/member/user/update-nickname?nickname="+param,
  };
  return post(params);
};
// 修改公司名
export const updateCompanyName = param => {
  const params = {
    url: "/app-api/member/user/update-company?companyName="+param,
  };
  return post(params);
};
// 修改头像
export const updateAvatar = param => {
  const params = {
    url: "/app-api/member/user/update-avatar",
    body: { ...param }
  };
  return post(params);
};

// 修改密码
export const updatePassword = param => {
  const params = {
    url: "/app-api/member/user/update-password"+param,
    // body: { ...param }
  };
  return post(params);
};
// x修改邮箱--第一步
export const checkEmailCode = param => {
  const params = {
    url: "/app-api/member/user/check-email-code"+param,
    // body: { ...param }
  };
  return post(params);
};
// x修改邮箱--第二步
export const updateEmail = param => {
  const params = {
    url: "/app-api/member/user/update-email"+param,
    // body: { ...param }
  };
  return post(params);
};

// 退出登录
export const authLogOut = param => {
  const params = {
    url: "/app-api/member/auth/logout",
    body: { ...param }
  };
  return post(params);
};


// 帮助列表
export const helpList = param => {
  const params = {
    url: '/app-api/member/help-list-app/page',
    query: { ...param },
  }
  return get(params)
}
// 帮助详情
export const helpDetail = param => {
  const params = {
    url: '/app-api/member/help-list-app/get',
    query: { ...param },
  }
  return get(params)
}

// 意见反馈
export const feedkackCreate = param => {
  const params = {
    url: "/app-api/member/feedkack/create",
    body: { ...param }
  };
  return post(params);
};

// 上传文件
export const upload = param => {
  const resp = {
    url: "/app-api/system/s3/upload",
    body: param
  };
  return postFile(resp);
};

// 消息类型
export const messageType = param => {
  const params = {
    url: '/app-api/content/message-type/list',
    query: { ...param },
  }
  return get(params)
}
// 消息列表
export const messageMember = param => {
  const params = {
    url: '/app-api/content/message-member/page',
    query: { ...param },
  }
  return get(params)
}
// 消息详情
export const messageDetail = param => {
  const params = {
    url: '/app-api/content/message/get',
    query: { ...param },
  }
  return get(params)
}

// 消息标为已读
export const updateMessageStatus = param => {
  const params = {
    url: "/app-api/content/message-member/update-status",
    body: param
  };
  return post(params);
};
// 消息删除
export const deleteMessage = param => {
  const params = {
    url: "/app-api/content/message-member/delete?ids="+param,
  };
  return post(params);
};


// WEBPACK FOOTER //
// ./src/http/user.js